import React, { Component } from 'react';
import AdminLayout from './layout';

import FetchCall from '../../API/FetchCall';

class verticalPreSchoolDetail extends Component {

    constructor(props) {
        super(props);
        this.state = {
          schoolDetails: '',
          photos_arr: [],
        };
        this.id = this.props.match.params.id;
        this.getPreSchoolInfo = this.getPreSchoolInfo.bind(this);
        this.getPreSchoolInfo();

    }


  componentDidMount() {
    console.log(this.props);
  }

  UNSAFE_componentWillMount() {

  }

  componentDidUpdate() {
  }

  async getPreSchoolInfo() {
    let response = await FetchCall.getPreSchoolDetails(this.id);
    console.log(response);
    if (response) {
      const data = response.data;
      this.setState({
        schoolDetails: data,
        url: data.url,
        photos_arr: data.photo_arr,
      });

    } else {
      return <div>Error</div>;
    }

  }

  gallery_image() {

    let photos = this.state.photos_arr !== undefined ? this.state.photos_arr : [];
    let rows = "";
    if (photos.length > 0) {
      rows = photos.map((photos, index) => {
        if (photos.name)
          return (
            <div class="col-md-4 float-left mt-4 p-0">
              <img src={this.state.url + photos.name} alt="Img" class="img-thumbnail" />
            </div>
          );
        return;
      });
    } else {
      rows = "";
    }
    return rows;

  }


  render() {
    const { schoolDetails } = this.state;
    console.log('schoolDetails', this.state);

        return (
            <React.Fragment>
                <AdminLayout>
                    
           <div class="col-lg-12 grid-margin stretch-card">
              <div class="card">
                <div class="card-body">
                  <h4 class="card-title">{schoolDetails.schoolName} - View</h4>
                                   
                  <div class="pt-3 detailsection">
                        

                       <div className="box-shadow-custom">
                        <div className="row">
                          <div className="form-group col-md-4">
                            <label>
                              Registration No
                            </label>
                            <p>{schoolDetails.registration_no ? schoolDetails.registration_no : 'NA'}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>
                              Owner Name
                            </label>
                            <p>{schoolDetails.owner_name ? schoolDetails.owner_name : 'NA'}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>
                              Organization Name
                            </label>
                            <p>{schoolDetails.schoolName}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>
                              Organization type
                            </label>
                            <p>{schoolDetails.sub_categories}</p>
                          </div>
                        </div>
                      </div>
                      <div className="box-shadow-custom">
                        <div className="row">
                          <div className="col-md-12 col-xs-12">
                            <span className="form-legend">
                              Address Information
                            </span>
                          </div>
                          <div className="form-group col-md-4">
                            <label>
                              Email Id
                            </label>
                            <p>{schoolDetails.email_id}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>
                              Phone Number
                            </label>
                            <p>{schoolDetails.phone_number}</p>
                          </div>

                          <div className="form-group col-md-4">
                            <label>
                              State
                            </label>
                            <p>{schoolDetails.state}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>
                              Location
                            </label>
                            <p>{schoolDetails.location}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>
                              Pincode
                            </label>
                            <p>{schoolDetails.pincode}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>
                              Address
                            </label>
                            <p>{schoolDetails.address}</p>
                          </div>
                          {/* <div className="form-group col-md-4">
                            <label>
                              Country
                              </label>
                            <p>{schoolDetails.country}</p>
                          </div> */}

                          <div className="form-group col-md-4">
                            <label>
                              Google Location Address
                            </label>
                            <p>{schoolDetails.google_location}</p>
                          </div>
                          <div className="form-group col-md-12">
                            <label>
                              About the School
                            </label>
                            <div dangerouslySetInnerHTML={{__html:schoolDetails.about_school}}></div>
                             
                          </div>
                        </div>
                      </div>
                      <div className="box-shadow-custom">
                        <div className="row">
                          <div className="col-md-12 col-xs-12">
                            <span className="form-legend">Key Information</span>
                          </div>


                          <div className="form-group col-md-4">
                            <label>Facilities</label>
                            <p>{schoolDetails.facilites}</p>
                          </div>

                          <div className="form-group col-md-4">
                            <label>From Timing</label>
                            {schoolDetails.from_time ? (<p>{schoolDetails.from_time} </p>) : (<p>--</p>)}

                          </div>
                          <div className="form-group col-md-4 ">
                            <label>To Timing</label>
                            {schoolDetails.to_time ? (<p> {schoolDetails.to_time} </p>) : (<p>--</p>)}
                          </div>

                          <div className="form-group col-md-4">
                            <label>
                              Number of Teachers
                            </label>
                            <p>{schoolDetails.number_of_teachers}</p>
                          </div>

                          <div className="form-group col-md-4">
                            <label>
                              Establishment Year
                            </label>
                            <p>{schoolDetails.est_year}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>
                              Website
                            </label>
                            <p>{schoolDetails.website}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>Website Search Keywords</label>
                            <p>{schoolDetails.keywords}</p>
                          </div>
                        </div>
                      </div>

                      <div className="box-shadow-custom">
                        <div className="row">
                          <div className="col-md-12 col-xs-12">
                            <span className="form-legend">
                              Admission Details
                            </span>
                          </div>
                          <div className="form-group col-md-4">
                            <label>
                              Application Fees
                            </label>
                            <p>{schoolDetails.processing_fee}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label> Documents </label>
                            <p>{schoolDetails.document_name}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>Admission Process</label>
                            <p>{schoolDetails.admission_process}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>
                              Admission Link
                            </label>
                            <p>{schoolDetails.admission_link}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>
                              Indicative Annual Fee(INR)
                            </label>
                            <p>{schoolDetails.avg_fee}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>
                              Other Fees
                            </label>
                            <p>{schoolDetails.other_fee}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>
                              Admission Fees
                            </label>
                            <p>{schoolDetails.admit_fee}</p>
                          </div>
                          <div className="form-group col-md-4">
                            <label>
                              Is Refundable (Admission Fees)
                            </label>
                            <p>{schoolDetails.isrefund === 1 ? 'Yes' : 'No'}</p>
                          </div>
                        </div>
                      </div>
                      <div className="box-shadow-custom">
                        <div className="row">
                          <div className="col-md-12 col-xs-12">
                            <span className="form-legend">Images</span>
                          </div>
                          <div className="form-group col-md-4">
                            <label>
                              Banner Images
                            </label>
                            {schoolDetails.images &&
                              <img src={schoolDetails.url + schoolDetails.images} alt="Img" class="img-thumbnail" />
                            }
                          </div>





                          <div class="col-md-12 float-left mt-4 p-0">
                            <label>
                              Gallery Images
                            </label>
                          </div>

                          {this.gallery_image()}

                        </div>
                      </div>

               
                  </div>
                </div>
              </div>
            </div>

                </AdminLayout>
            </React.Fragment>
        )
    }
}


export default verticalPreSchoolDetail;


// WEBPACK FOOTER //
// ./src/components/bewise/verticalPreSchoolDetail.jsx